"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEWFORM_SUPPORT_EMAIL = exports.NFONE_STARTER_BONUS = exports.NFONE_PAYOUT_MONTHLY_CAP_USD = exports.NFONE_BRAND_DESCRIPTION_MAX = exports.NFONE_MAX_OPEN_BRAND_APPLICATIONS = exports.SUBMISSIONS_PAUSED_NOTE_MAX = exports.NFONE_META_CODE_GUIDE_URL = exports.NFONE_SPARK_CODE_GUIDE_URL = exports.NFONE_APP_STORE_URL = exports.NFONE_APP_STORE_ID = exports.NFONE_SUPPORT_EMAIL = void 0;
/**
 * The NewForm One creator-support mailbox. Reply-to on every creator-facing
 * email, and the address shown wherever the portal or /join tells a creator
 * how to reach us. It is a Google Workspace mailbox forwarded into Plain, so
 * an emailed question lands in the same queue as a portal chat.
 *
 * On newform.ai, not newform.com: Plain only accepts alternate addresses on
 * the same domain as the workspace's main support address (support@newform.ai).
 *
 * Outbound mail still goes *from* the Resend sending domain (see
 * `emailSendingDomain`); this address is only ever a reply-to or a link.
 */
exports.NFONE_SUPPORT_EMAIL = "nfone@newform.ai";
/** Shared by Safari's Smart App Banner and the native minimum-build gate. */
exports.NFONE_APP_STORE_ID = "6818672502";
exports.NFONE_APP_STORE_URL = `https://apps.apple.com/us/app/newform-one-ugc-creator/id${exports.NFONE_APP_STORE_ID}`;
/**
 * Screen-recorded refreshers on where TikTok's Spark code and Instagram's
 * partnership ad code live. Linked from the welcome email and the submit
 * screen's code help (web and iOS, which repeats them in
 * `Features/Submit/AdCodeHelpSheet.swift`).
 */
exports.NFONE_SPARK_CODE_GUIDE_URL = "https://drive.google.com/file/d/1GyolFPzzzT5Rsvsq1Hb7D3D6anomEHo_/view?usp=sharing";
exports.NFONE_META_CODE_GUIDE_URL = "https://drive.google.com/file/d/1uOor6fmQ3TLQBAzzb4ySogl1VjtFUD5M/view?usp=sharing";
/**
 * The longest note staff can leave creators while a program's submissions are
 * paused ("Back on Monday"). The staff setting caps the field with it and the
 * settings write refuses anything longer.
 */
exports.SUBMISSIONS_PAUSED_NOTE_MAX = 300;
/**
 * How many brand applications a creator can have waiting at once. Each one is
 * a separate decision in the staff queue, so the cap keeps one creator from
 * filling it; withdrawing a waiting application frees a slot.
 */
exports.NFONE_MAX_OPEN_BRAND_APPLICATIONS = 3;
/** The longest brand description staff can write for the brand list. */
exports.NFONE_BRAND_DESCRIPTION_MAX = 280;
/**
 * The creator agreement's Monthly Cap (Section 2(a)): what a creator earns
 * from one brand in a calendar month never exceeds this, and anything over it
 * that month is not paid later. The backend applies it
 * (`apps/backend/src/lib/creatorPortal/payoutCap.ts`); the portal and the
 * staff queue only quote it. The agreement and the /join copy state the same
 * number in prose; change them together.
 */
exports.NFONE_PAYOUT_MONTHLY_CAP_USD = 10000;
/**
 * The new-creator bonus promised on /join: approve this many videos within
 * this many days of joining NewForm One and earn the amount. The apply-page
 * copy (`apps/frontend/i18n/creator/messages/{en,es}/apply.json`) and the iOS
 * application screens state the same numbers in prose; change them together.
 */
exports.NFONE_STARTER_BONUS = {
    usd: 250,
    approvedVideos: 1,
    windowDays: 10,
};
/**
 * The workspace's main support mailbox, for staff and client-facing mail
 * (Framework). Creators get NFONE_SUPPORT_EMAIL instead.
 */
exports.NEWFORM_SUPPORT_EMAIL = "support@newform.ai";
